import React from 'react';
import { Box, Button, CircularProgress, InputAdornment, MenuItem, Paper, TextField } from '@mui/material';
import { Refresh as RefreshIcon, Search as SearchIcon, SettingsOutlined as SettingsIcon } from '@mui/icons-material';
import { STATUS_OPTIONS, hasAnyFilter } from '../constants';
import { StatusFilter, TimesheetFilters } from '../types';

interface Props {
  filters: TimesheetFilters;
  loading: boolean;
  /** Есть право на настройки: кнопка не рендерится без него */
  canSettings: boolean;
  onSearch: (search: string) => void;
  onStatus: (status: StatusFilter) => void;
  onReset: () => void;
  onRefresh: () => void;
  onSettings: () => void;
}

const TimesheetToolbar: React.FC<Props> = ({ filters, loading, canSettings, onSearch, onStatus, onReset, onRefresh, onSettings }) => (
  <Paper elevation={0} variant="outlined" sx={{ p: 1.5, borderRadius: 2, bgcolor: '#fff', borderColor: '#e2e8f0' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
      <TextField
        size="small" placeholder="№ аптеки, логин, регион" value={filters.search}
        onChange={e => onSearch(e.target.value)} sx={{ minWidth: 260 }}
        inputProps={{ maxLength: 100, 'aria-label': 'Поиск аптеки' }}
        InputProps={{
          startAdornment: <InputAdornment position="start"><SearchIcon sx={{ color: 'text.secondary', fontSize: 20 }} /></InputAdornment>
        }}
      />

      <TextField
        select size="small" value={filters.status} onChange={e => onStatus(e.target.value as StatusFilter)}
        sx={{ minWidth: 180 }} inputProps={{ 'aria-label': 'Статус табеля' }}
      >
        {STATUS_OPTIONS.map(o => <MenuItem key={o.value || 'all'} value={o.value}>{o.label}</MenuItem>)}
      </TextField>

      <Box sx={{ flexGrow: 1 }} />

      <Button
        variant="outlined" color="inherit" size="small" onClick={onReset} disabled={!hasAnyFilter(filters)}
        sx={{ height: 40, textTransform: 'none', fontWeight: 600, borderRadius: 1.5, borderColor: '#c4c4c4' }}
      >
        Сброс
      </Button>
      <Button
        variant="outlined" size="small" onClick={onRefresh} disabled={loading}
        startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <RefreshIcon />}
        sx={{ height: 40, textTransform: 'none', fontWeight: 600, borderRadius: 1.5 }}
      >
        Обновить
      </Button>
      {canSettings && (
        <Button
          variant="contained" size="small" onClick={onSettings} startIcon={<SettingsIcon />}
          sx={{ height: 40, textTransform: 'none', fontWeight: 600, borderRadius: 1.5, px: 2 }}
        >
          Настройки
        </Button>
      )}
    </Box>
  </Paper>
);

export default React.memo(TimesheetToolbar);
